import { Info } from 'lucide-react'
import { twMerge } from 'tailwind-merge'

import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/tooltip'

interface MapStatusBadgeProps {
  status: 1 | 2 | 3
  className?: string
}

const statusText = {
  1: 'Aprovado',
  2: 'Reprovado',
  3: 'Inconclusivo',
}

const statusDescription = {
  1: 'Os resultados do mapa foram aprovados pela 6BIOS',
  2: 'Os resultados do mapa foram reprovados pela 6BIOS',
  3: 'Não foi possível concluir a análise. Será feita uma nova em breve.',
}

export function MapStatusBadge({ status, className }: MapStatusBadgeProps) {
  return (
    <div
      className={twMerge(
        'relative w-fit items-center rounded-full bg-alert-success px-4 py-1 pr-8 text-sm font-semibold text-white',
        className,
        status === 2 && 'bg-alert-danger',
        status === 3 && 'bg-alert-warning',
      )}
    >
      {statusText[status]}

      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <Info className="absolute right-2 top-1/2 size-5 -translate-y-1/2 cursor-pointer" />
          </TooltipTrigger>
          <TooltipContent>
            <p>{statusDescription[status]}</p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    </div>
  )
}
